<template>
  <div class="page_wrapper">
    <header class="header">
      <nav class="navbar navbar-inverse navbar-fixed-top">
        <div class="container-fluid">
          <div class="navbar-header" :class="areaExpanded ? 'fl-left' : ''">
            <router-link to="/" title="Logo" class="logo">
              <img class="hide-xs" id="logo" alt="logo" src="/static/images/logos/RAMS_Logo.svg" />
              <img
                class="show-xs"
                id="logo"
                alt="logo"
                src="/static/images/logos/RAMS_Mobile_Logo.svg"
              />
            </router-link>
          </div>
          <div
            id="burger_menu"
            type="button"
            class="display_xs collapsed"
            aria-expanded="false"
            @click="areaExpanded = !areaExpanded"
            data-toggle="collapse"
            data-target="#NavBar_DropDown"
          >
            <!-- menu & close options in tab & mobile versions -->
            <div class="x"></div>
            <div class="y"></div>
            <div class="z"></div>
          </div>
          <ul class="nav navbar-nav hide_xs">
            <li>
              <router-link to="/terms-of-service" class="rams-terms"
                >RAMS SaaS Agreement</router-link
              >
            </li>
            <li>
              <a
                class="rams-terms"
                href="https://www.emergobyul.com/terms-of-use?action"
                target="_blank"
                >Emergo by UL Terms of Use</a
              >
            </li>
            <li>
              <a
                class="rams-terms pr-22"
                href="https://www.emergobyul.com/privacy-policy"
                target="_blank"
                >Privacy Policy</a
              >
            </li>
            <li class="mr-rt-24">
              <router-link class="btn button_login" to="/login">Log In</router-link>
            </li>
            <li>
              <router-link class="btn emergo-green-button" to="/register">Sign Up</router-link>
            </li>
          </ul>
          <ul id="NavBar_DropDown" aria-expanded="false" class="nav navbar-nav collapse">
            <li>
              <a data-toggle="collapse" data-target="#NavBar_DropDown" @click="redirect('/login')"
                >Log In</a
              >
            </li>
            <li>
              <a
                data-toggle="collapse"
                data-target="#NavBar_DropDown"
                @click="redirect('/register')"
                >Sign Up</a
              >
            </li>
            <li>
              <a
                data-toggle="collapse"
                data-target="#NavBar_DropDown"
                @click="redirect('/terms-of-service')"
                >RAMS SaaS Agreement
              </a>
            </li>
            <li>
              <a href="https://www.emergobyul.com/terms-of-use?action" target="_blank"
                >Emergo by UL Terms of Use</a
              >
            </li>
            <li>
              <a href=" https://www.emergobyul.com/privacy-policy" target="_blank"
                >Privacy Policy</a
              >
            </li>
          </ul>
        </div>
      </nav>
    </header>
    <main class="subpage" :class="areaExpanded ? 'disp-none' : ''">
      <section>
        <div class="china-login-box china-container" v-if="showDialog === 'true'">
          <button type="button" class="close" @click="showDialog = 'false'">&times;</button>
          <div class="table-container">
            <div>
              <img
                src="/static/images/icons/info_icon_active.svg"
                class="info-icon"
                alt="info-icon"
              />
            </div>
            <div>
              <h3 class="text-emergo-dark-blue china-header">China-based Customer?</h3>
              <p class="china-content">
                If you are a user located in China, use this link to login/sign up for RAMS.
              </p>
            </div>
          </div>
          <div class="center">
            <a href="https://demo-rams.emergobyul.cn/" class="btn emergo-green-button">
              Access RAMS
            </a>
          </div>
        </div>
        <router-view></router-view>
        <div class="flex-container container banner-container" v-if="banners && banners.length">
          <notification-banner :notification="banners[0]"></notification-banner>
        </div>
      </section>
    </main>
    <div
      class="col-sm-12 flex-container security_logos mb-10"
      :class="areaExpanded ? 'disp-none' : ''"
    >
      <span class="disp-flex">
        <img src="/static/images/logos/lets_encrypt.svg" class="encrypt_logo" alt="encrypt-img" />
        <img src="/static/images/logos/microsoft_azure.svg" class="azure_logo" alt="azure-img" />
        <div class="azure_security_logo-pt-5">
          <img
            src="/static/images/logos/azr_security_logo.svg"
            class="azure_security_logo"
            alt="security-img"
          />
          <span class="azure_security_text">Azure Security Center</span>
        </div>
      </span>
    </div>
    <footer class="" :class="areaExpanded ? 'disp-none' : ''">
      <nav class="footer_content">
        <ul class="footer-copyright">
          <li>© {{ getFullYear() }} EMERGO by UL. All rights reserved.</li>
        </ul>
      </nav>
    </footer>
  </div>
</template>
<script>
import moment from 'moment';
import NotificationBanner from '../SystemNotifications/NotificationBanner.vue';
import { getActiveBanner } from '../../apis/systemNotifications';

export default {
  data() {
    return {
      areaExpanded: false,
      banners: [],
      showDialog: false
    };
  },
  components: {
    NotificationBanner
  },
  methods: {
    redirect(url) {
      this.areaExpanded = false;
      this.$router.push(url);
    },
    getFullYear() {
      return moment().format('YYYY');
    }
  },
  async created() {
    this.banners = await getActiveBanner();
    this.areaExpanded = false;
    this.showDialog = process.env.VUE_APP_SHOW_CHINA_LOGIN;
  }
};
</script>
<style scoped>
.china-header {
  margin: 5px 0;
  font-weight: 500;
}
.china-content {
  font-size: 14px;
}
.china-login-box {
  position: absolute;
  top: 110px;
  width: 400px;
  right: 20px;
}
.china-container {
  background: #ffffff;
  -webkit-box-shadow: 0px 4px 10px rgb(0 0 0 / 25%);
  box-shadow: 0px 4px 10px rgb(0 0 0 / 25%);
  border-radius: 4px;
  padding: 10px 15px 15px;
  z-index: 1;
}
.china-login-box .close {
  font-size: 25px;
  color: #000;
  opacity: 0.4;
  background-color: #fff;
  top: 0;
  right: 0;
}
.china-login-box .table-container {
  display: flex;
  align-items: center;
}
.china-login-box .table-container .info-icon {
  width: 35px;
  margin-right: 15px;
}
.hide_banner ~ .banner-container,
.hide_banner ~ .security_logos {
  display: none;
}
.banner-container {
  margin: 20px auto 20px;
}
#burger_menu[aria-expanded='true'] > div.x {
  transform: rotate(45deg);
  transform-origin: top left;
}
#burger_menu[aria-expanded='true'] > div.y {
  background: #ffffff;
}
#burger_menu[aria-expanded='true'] > div.z {
  transform: rotate(-45deg);
  transform-origin: bottom left;
  margin: 7px 5px 5px 5px;
}
#burger_menu {
  padding-top: 25px;
  height: 40px;
  width: 40px;
  cursor: pointer;
  z-index: 1;
  appearance: none;
}
div.x,
div.y,
div.z {
  height: 3px;
  width: 26px;
  margin: 5px;
  background: #0b3c61;
  border-radius: 2px;
  -webkit-transition: all 200ms ease-out;
  -o-transition: all 200ms ease-out;
  transition: all 200ms ease-out;
}
.navbar-inverse {
  background: #ffffff;
  border: none;
  padding: 0px 48px 0px 40px;
}
.navbar-inverse .container-fluid {
  padding-left: 0px;
  padding-right: 0px;
  border-bottom: 0.8px solid #bdbdbd;
}
.navbar-inverse .navbar-nav > li > .button_login,
.navbar-inverse .navbar-nav > li > .button_login:focus,
.navbar-inverse .navbar-nav > li > .button_login:active {
  background: #ffffff;
  border: 1px solid #0b3c61;
  color: #0b3c61;
  box-sizing: border-box;
  border-radius: 20px;
  font-weight: 500;
  font-size: 18px;
  top: 5px;
  padding: 7px 30px;
}
.navbar-inverse .navbar-nav > li > .button_login:hover {
  background: #ffffff;
  color: #0b3c61;
  box-shadow: none;
}
.navbar-inverse .navbar-nav > li > .emergo-green-button,
.navbar-inverse .navbar-nav > li > .emergo-green-button:focus,
.navbar-inverse .navbar-nav > li > .emergo-green-button:active {
  background-color: #4c9e45;
  border: 1px solid #4c9e45;
  color: #ffffff;
  top: 5px;
  padding: 7px 24px;
}
.navbar-inverse .navbar-nav > li > .emergo-green-button:hover {
  background-color: #4c9e45;
  border: 1px solid #4c9e45;
  color: #ffffff;
  box-shadow: none;
}
.navbar-inverse .navbar-nav > li > a {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  color: #0b3c61;
  opacity: 1;
}
.navbar-inverse .navbar-nav > li > a.rams-terms {
  line-height: 18px;
}
.btn {
  padding: 7px 30px;
}
#logo {
  display: block;
  max-width: 130px;
  max-height: 73px;
}
.display_xs {
  display: none;
}
.mr-rt-24 {
  margin-right: 24px;
}
/* header, footer and main block --------- */
footer {
  padding: 0px 42px 0px 40px;
}
.footer_menu {
  padding: 12px 0px 0px 0px;
}
.footer_menu > li {
  margin-right: 40px;
  padding-right: 40px;
}
.footer_menu > li > a {
  color: #ffffff;
  font-family: roboto;
  font-size: 16px;
  font-weight: 700;
  padding-bottom: 5px;
}
.footer_menu > li > a:hover {
  border-bottom: 2px solid white;
}
.footer-copyright {
  color: rgba(0, 0, 0, 0.7);
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  padding: 5px;
}
.footer_content > .footer-copyright {
  margin-bottom: 0px;
}
.footer-copyright > li {
  padding-right: 14px;
}
.footer_content {
  border-top: 0.8px solid #bdbdbd;
  text-align: center;
}
.footer_content > ul {
  white-space: nowrap;
  list-style: none;
  margin: 10px;
}
.footer_content > ul > li {
  display: inline;
}
.navbar-nav.hide_xs {
  padding-top: 25px;
}
.page_wrapper .container-fluid .navbar-header {
  padding-top: 25px;
}

footer {
  background: #ffffff;
  margin-top: 50px;
  height: 65px;
}
.navbar-inverse .navbar-nav {
  border: none;
  background: #ffffff;
  float: right;
}
#burger_menu[aria-expanded='true'] {
  float: right;
}
.container-fluid .navbar-header.fl-left {
  float: left;
}
.page_wrapper {
  position: relative;
}
main {
  min-height: 100vh;
  padding-bottom: 30px;
  padding-top: 84px;
  position: relative;
  margin: 0;
}
footer {
  bottom: 0;
  width: 100%;
}
.encrypt_logo {
  width: 111px;
  height: 26px;
  margin-right: 15px;
}
.azure_logo {
  width: 137px;
  height: 31px;
  position: relative;
  margin-right: 15px;
}
.azr_security_logo {
  width: 26px;
  height: 26px;
}
.disp-flex {
  display: flex;
}
.show-xs {
  display: none !important;
}
.azure_security_logo-pt-5 {
  padding-top: 5px;
}
.disp-none {
  display: none;
}
.nav > li > a {
  padding-right: 40px;
}
.navbar-nav > li > a.rams-terms.pr-22 {
  padding-right: 56px;
}
@media screen and (max-width: 767px) {
  main {
    padding-top: 60px;
  }
  .show-xs {
    display: inline !important;
  }
  .hide-xs {
    display: none !important;
  }
  .azure_security_logo-pt-5 {
    padding-top: 0px;
  }
  .navbar-inverse {
    padding: 0px 15px 0px 15px;
  }
  footer {
    padding: 0px 15px 0px 15px;
    margin-top: 15px !important;
  }
}
@media (min-width: 375px) and (max-width: 767px) {
  .navbar-inverse .container-fluid {
    padding-right: 15px;
  }
  .security_logos .disp-flex {
    display: -webkit-box;
  }
  .encrypt_logo {
    width: 85px;
    height: 19px;
    margin-right: 0px;
  }
  .azure_logo {
    width: 105px;
    height: 23px;
    margin-right: 0px;
  }
  .azr_security_logo {
    width: 19px;
    height: 19px;
  }
  .azure_security_text {
    font-size: 12px;
  }
  .china-login-box {
    position: relative;
    margin: 20px auto 0;
    width: 95%;
    right: 0;
    top: 0;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .china-login-box {
    position: relative;
    margin: 20px 20px 20px auto;
    width: 450px;
    right: 0;
    top: 0;
  }
}
@media (min-width: 768px) and (max-width: 1115px) {
  .security_logos {
    padding-left: 0px;
  }
  .security_logos .disp-flex {
    display: -webkit-box;
  }
  .rams-dashboard-logo {
    width: 450px;
    height: 459x;
  }
  .encrypt_logo {
    width: 95px;
    height: 24px;
    margin-right: 0px;
  }
  .azure_logo {
    width: 110px;
    height: 29px;
    position: relative;
    top: 2px;
    margin-right: 0px;
  }
}
@media screen and (max-width: 374px) {
  .china-login-box {
    position: relative;
    margin: 20px auto 0;
    width: 95%;
    right: 0;
    top: 0;
  }
}
@media screen and (min-width: 1301px) {
  #NavBar_DropDown {
    display: none;
  }
}
@media screen and (max-width: 1300px) {
  .display_xs {
    display: block;
  }
  .hide_xs {
    display: none;
  }
  .navbar-inverse .navbar-nav {
    float: unset;
  }
  #NavBar_DropDown > li {
    float: unset;
  }
  .navbar-header {
    float: right;
  }
  .page_wrapper .container-fluid .navbar-header {
    padding-top: 15px;
  }
  #NavBar_DropDown {
    margin: 89px -15px 0;
    height: 100vh;
    padding-left: 15px;
  }
  main {
    padding-bottom: 0px;
  }
  footer {
    margin-top: 70px;
  }
}
</style>
